export default __webpack_public_path__ + "static/media/reveal_contact_info.5983a59b.svg";